import { ref } from 'vue'
import { inBrowser } from '@xzx-design/utils'

import type { Ref } from 'vue'

type VisibilityState = 'hidden' | 'visible'

let visibility: Ref<VisibilityState>

export function usePageVisibility() {
  if (!visibility) {
    visibility = ref<VisibilityState>('visible')

    if (inBrowser) {
      const update = () => {
        visibility.value = document.hidden ? 'hidden' : 'visible'
      }

      update()
      window.addEventListener('visibilitychange', update)
    }
  }

  return visibility
}
